import { Injectable } from '@angular/core';
import { OverlayContainer } from '@angular/cdk/overlay';

@Injectable({
  providedIn: 'root',
})
export class CdkOverlayContainer extends OverlayContainer {
  setContainerElement(element: HTMLElement) {
    this._containerElement = element;
  }

  protected override _createContainer() {
    return;
  }
}
